import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";

function Sidebar() {
  const [openUserMenu, setOpenUserMenu] = useState(false);
  const [openStaffMenu, setOpenStaffMenu] = useState(false);
  const [openSetting, setOpenSetting] = useState(false);
  const [openConf, setOpenConf] = useState(false);
  const [openReportsMenu, setOpenReportsMenu] = useState(false); // ✅ Tambahan untuk Reports dropdown
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="sidebar">
      {/* Sidebar Header */}
      <div className="sidebar-header">
        <h5 className="sidebar-title-main">Admin Panel</h5>
      </div>

      {/* Dashboard */}
      <div className="sidebar-section">
        <p className="sidebar-title text-muted">Dashboard</p>
        <Link
          to="/"
          className={`sidebar-link ${isActive("/") ? "active" : ""}`}
        >
          <i className="fas fa-home me-2"></i> Admin Dashboard
        </Link>
      </div>

      {/* Applications */}
      <div className="sidebar-section">
        <p className="sidebar-title text-muted">Applications</p>

        {/* User Management */}
        <div className="sidebar-dropdown">
          <button
            className="dropdown-toggle-btn"
            onClick={() => setOpenUserMenu(!openUserMenu)}
          >
            <i className="fas fa-user me-2"></i>
            <span>User Management</span>
            <i
              className={`fas fa-chevron-${openUserMenu ? "up" : "down"
                } ms-auto small text-secondary`}
            ></i>
          </button>
          <div className={`dropdown-body ${openUserMenu ? "show" : ""}`}>
            <Link
              to="/users"
              className={`sidebar-sublink ${isActive("/users") ? "active" : ""
                }`}
            >
              • User List
            </Link>
          </div>
        </div>

        {/* Staff Management */}
        <div className="sidebar-dropdown">
          <button
            className="dropdown-toggle-btn"
            onClick={() => setOpenStaffMenu(!openStaffMenu)}
          >
            <i className="fas fa-users me-2"></i>
            <span>Staff Management</span>
            <i
              className={`fas fa-chevron-${openStaffMenu ? "up" : "down"
                } ms-auto small text-secondary`}
            ></i>
          </button>
          <div className={`dropdown-body ${openStaffMenu ? "show" : ""}`}>
            <Link
              to="/staff"
              className={`sidebar-sublink ${isActive("/staff") ? "active" : ""
                }`}
            >
              • Staff List
            </Link>
          </div>
        </div>

        {/* Transactions */}
        <Link
          to="/transactions"
          className={`sidebar-link ${isActive("/transactions") ? "active" : ""}`}
        >
          <i className="fas fa-exchange-alt me-2"></i> Transactions
        </Link>

        {/* ✅ Reports Dropdown */}
        <div className="sidebar-dropdown">
          <button
            className="dropdown-toggle-btn"
            onClick={() => setOpenReportsMenu(!openReportsMenu)}
          >
            <i className="fas fa-chart-line me-2"></i>
            <span>Reports</span>
            <i
              className={`fas fa-chevron-${openReportsMenu ? "up" : "down"
                } ms-auto small text-secondary`}
            ></i>
          </button>
          <div className={`dropdown-body ${openReportsMenu ? "show" : ""}`}>
            <Link
              to="/reports/transactions"
              className={`sidebar-sublink ${isActive("/reports/transactions") ? "active" : ""
                }`}
            >
              • Transaction Report
            </Link>
            <Link
              to="/reports/withdraw-approvement"
              className={`sidebar-sublink ${isActive("/reports/withdraw-approvement") ? "active" : ""
                }`}
            >
              • Withdraw Approvement
            </Link>
          </div>
        </div>
      </div>

      {/* Settings */}
      <div className="sidebar-section">
        <p className="sidebar-title text-muted">Settings</p>
        <div className="sidebar-dropdown">
          <button
            className="dropdown-toggle-btn"
            onClick={() => setOpenSetting(!openSetting)}
          >
            <i className="fas fa-cog me-2"></i>
            <span>Configuration</span>
            <i
              className={`fas fa-chevron-${openSetting ? "up" : "down"
                } ms-auto small text-secondary`}
            ></i>
          </button>
          <div className={`dropdown-body ${openSetting ? "show" : ""}`}>
            <Link
              to="/videoyoutubelist"
              className={`sidebar-sublink ${isActive("/videoyoutubelist") ? "active" : ""
                }`}
            >
              • Video Youtube List
            </Link>
            <Link
              to="/packagelist"
              className={`sidebar-sublink ${isActive("/packagelist") ? "active" : ""
                }`}
            >
              • Package List
            </Link>
          </div>
        </div>

        <div className="sidebar-dropdown">
          <button
            className="dropdown-toggle-btn"
            onClick={() => setOpenConf(!openConf)}
          >
            <i className="fas fa-cog me-2"></i>
            <span>Settings</span>
            <i
              className={`fas fa-chevron-${openConf ? "up" : "down"
                } ms-auto small text-secondary`}
            ></i>
          </button>
          <div className={`dropdown-body ${openConf ? "show" : ""}`}>
            <Link
              to="/crypto-bank"
              className={`sidebar-sublink ${isActive("/crypto-bank") ? "active" : ""
                }`}
            >
              • Crypto Bank
            </Link>
            <Link
              to="/"
              className={`sidebar-sublink ${isActive("/") ? "active" : ""
                }`}
            >
              • UI Comments and News
            </Link>
          </div>
        </div>


      </div>
    </div>
  );
}

export default Sidebar;
